import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableExtensibleComponent } from './table-extensible.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TableExtensibleComponent],

  exports: [TableExtensibleComponent],
  imports: [CommonModule, AngularMaterialModule, FlexLayoutModule, FormsModule, ReactiveFormsModule],
})
export class TableExtensibleModule {}
